import React, { useEffect, useState } from 'react';
import './mobile-nav-menu.scss';
import 'hamburgers/_sass/hamburgers/hamburgers.scss';
import { NavLink } from 'react-router-dom';
import Env from '../../Env';
import HamburgerMenu from 'components/hamburger-menu/hamburger-menu';
import clsx from 'clsx';
import Links from 'constants/links';
import useFilteredRoutes from 'components/use-filtered-routes/use-filtered-routes';
import GlobalSearch from 'components/global-search/GlobalSearch';
import { useSelector } from 'react-redux';

const MobileNavMenu = ({
  logoutUser,
  onYourProfileClick,
  routes,
  hasTopBar,
  isSearchActive,
  isImpersonating,
  isMaintenanceActive,
}) => {
  const filteredRoutes = useFilteredRoutes(routes);

  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const isAdminPortal = Env.isAdminPortal();
  const globalSearchLoaded = useSelector((state) => state.cardsStore.globalSearchLoaded);
  const globalSearchResult = useSelector((state) => state.cardsStore.globalSearchResult);
  const isMobile = window.innerWidth < 992;

  useEffect(() => {
    if (globalSearchLoaded && globalSearchResult && isMobile) {
      mobileMenuToggler();
    }
  }, [globalSearchLoaded]);

  const mobileMenuToggler = () => {
    setMobileMenuActive(!mobileMenuActive);

    if (mobileMenuActive){
      document.body.style.overflow = 'auto';
      document.getElementById('bodyScroll').style.overflow  = 'auto';
    }
    else {
      document.body.style.overflow = 'hidden';
      document.getElementById('bodyScroll').style.overflow  = 'hidden';
    }
  };

  const subMenuToggler = (e) => {
    const target = e.target.getAttribute('name');
    var targetElement = document.getElementById(target);
    if (targetElement.classList.contains('hidden')){
      e.target.classList.add('active');
      targetElement.classList.remove('hidden');
    }
    else {
      e.target.classList.remove('active');
      targetElement.classList.add('hidden');
    }
  };

  const isActive = (items) => {
    const currentPath = window.location.pathname;

    return items && items.length > 0 && items.some(item => item.path === currentPath);
  };

  return (
    <>
      <HamburgerMenu isActive={mobileMenuActive} onMenuClick={mobileMenuToggler} />
      {mobileMenuActive && filteredRoutes.length > 1 && (
        <div 
          className={clsx(
            'mobile-nav-menu',
            { 'mobile-nav-menu--has-top-nav': hasTopBar },
            { 'mobile-nav-menu--is-impersonating': isImpersonating && !isAdminPortal },
            { 'mobile-nav-menu--is-maintenance-active': isMaintenanceActive && isAdminPortal },
            { 'mobile-nav-menu--is-maintenance-and-search-active': isMaintenanceActive && isSearchActive },
            { 'mobile-nav-menu--is-search-active': isSearchActive }
          )}
        >
          <ul className="mobile-nav-items mobile-nav-items-top">
            {filteredRoutes
              .map((route, index) => {
                const routeIsActive = isActive(route.subMenuItems);

                return <li className={'mobile-main-menu-item'} 
                  key={`${route.name}-${index}`}>
                  <NavLink exact to={route.path} name={route.name} onClick={route.subMenuItems && !route.component ? subMenuToggler : mobileMenuToggler}>{route.text}</NavLink>
                  {route.subMenuItems ?
                    <div name={route.name} onClick={subMenuToggler} id="mobile-submenu-launcher" className={`mobile-submenu-launcher${routeIsActive ? ' active' : ''}`}><span className="horizontal"/><span className="vertical"/></div> : null}
                  <ul id={route.name} className={`${routeIsActive ? '' : 'hidden'}`}>
                    {
                      route.subMenuItems && route.subMenuItems.map((subMenuItem, i) => (
                        (<li key={`${subMenuItem.name}-${i}`}>
                          <NavLink to={subMenuItem.path} onClick={mobileMenuToggler}>{subMenuItem.text}</NavLink>
                        </li>)
                      ))
                    }
                  </ul>
                </li>;
              })}
          </ul>
          <ul className="mobile-nav-items mobile-nav-items-bottom">
            {!isAdminPortal && <li><GlobalSearch /></li>}
            <li onClick={onYourProfileClick} >Your Profile</li>
            {/* TASK-33286 Remove Reset Password Link */}
            {/* <li onClick={resetPassword} >Reset Password</li> */}
            <li><a href={Links.CONTACT_US} target='_blank' rel="noopener noreferrer">Contact Us</a></li>
            <li><a href={Links.SUPPORT} target='_blank' rel="noopener noreferrer">Support</a></li>
            <li onClick={logoutUser}>Logout</li>
          </ul>
        </div>
      )}
    </>
  );
};

export default MobileNavMenu;
